import React from 'react';
import Dialog from '../components/ui/Dialog';

const LegalModal = ({ isOpen, onClose, title, content }) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} title={title} className="max-w-3xl">
        <div className="break-words text-base leading-relaxed [&_h3]:mb-2 [&_h3]:mt-6 [&_h3]:text-lg [&_h3]:font-semibold [&_p]:my-3 [&_ul]:list-disc [&_ul]:pl-5">
          {content}
        </div>
    </Dialog>
  );
};

export default LegalModal;
